import { useEffect } from 'react';
import { applyTheme, useAppStore } from '@/app/store';

export function useThemeEffect(): void {
  const theme = useAppStore((state) => state.theme);
  useEffect(() => {
    applyTheme(theme);
    if (theme !== 'system') return;
    const query = window.matchMedia('(prefers-color-scheme: dark)');
    const listener = () => applyTheme('system');
    query.addEventListener('change', listener);
    return () => query.removeEventListener('change', listener);
  }, [theme]);
}
